import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import CoreLayout from './coreLayout';
import Divider from 'material-ui/Divider'
import LoadingIndicator from '../components/loadingIndicator'
import Messages from '../constants/messages'
import Paper from 'material-ui/Paper'
import PropTypes from 'prop-types'
import Typography from 'material-ui/Typography'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  component: PropTypes.func.isRequired,
  hasReceivedAppContext: PropTypes.bool.isRequired,
  title: PropTypes.string
}

const styles = theme => ({
  copyright: {
    display: 'inline-block',
    width: '100%',
    textAlign: 'left'
  },
  divider: {
    marginBottom: 25
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    padding: 10,
    fontSize: 12
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  headerTitle: {
    marginBottom: '0.8em'
  },
  isHidden: {
    display: 'none'
  },
  main: {
    minWidth: 320,
    maxWidth: 600,
    width: '30%',
    margin: 'auto'
  },
  nordstromLogo: {
    width: '70%',
    paddingBottom: 30
  },
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3
  }),
})

class HeaderLayout extends Component {
  constructor(props) {
    super(props);
    this.state = { isHidden: true }
  }

  toggleIsHidden = () => {
    setTimeout(() => {
      this.setState({isHidden: false})
    }, 100);
  }

  componentDidMount = () => {
    this.toggleIsHidden()
  }
  
  render() {
    const { classes, hasReceivedAppContext, title, ...rest } = this.props
    const Component = this.props.component
    return (
      <CoreLayout {...rest} component={matchProps => (
        <section className={this.state.isHidden ? classes.isHidden : null}>
          {!hasReceivedAppContext ? <LoadingIndicator infoText={Messages['uiComponents']['LOADING_MSG']} /> :
            <section>
              <section className={classes.main}>
                <Paper className={classes.paper} elevation={4}>
                  <header className={classes.header}>
                    <img
                      data-test-id="nordstrom-logo"
                      src="https://s3-us-west-2.amazonaws.com/nauth-prod/Design+Assets/nord_logo/nord_logo_black%402x.png"
                      className={classes.nordstromLogo}
                      alt="nordstrom logo" />
                    <Typography type="title" className={classes.headerTitle}>
                      {Messages['uiComponents']['APPLICATION_NAME']} {title}
                    </Typography>
                  </header>
                  <Divider className={classes.divider} />
                  <Component {...matchProps} />
                </Paper>
              </section>
              <footer className={classes.footer}>
                <span className={classes.copyright} data-test-id="nordstrom-copy">&copy; {`${(new Date()).getFullYear()} Nordstrom, Inc.`}</span>
              </footer>
            </section>
          }
        </section>
      )} />
    )
  }
}

const mapStateToProps = state => ({
  hasReceivedAppContext: state.loading.hasReceivedAppContext,
})

HeaderLayout.propTypes = PROP_TYPES

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
  )
)(HeaderLayout)